import { memo } from 'react';
import styled from 'styled-components';

/* -----------------------------------
   Table Data Cell (Modern Font & Row Hover)
----------------------------------- */
const StyledTableData = styled.td`
  padding: ${({ compact }) => (compact ? '6px 12px' : '14px 16px')};
  font-size: 14px;
  font-family: 'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; /* modern clean font */
  font-weight: 500; /* slightly bolder but not heavy */
  color: #1f1f1f; /* darker text for readability */
  vertical-align: middle;
  text-align: ${({ align }) => align || 'left'};
  border-bottom: 1px solid #e0e0e0;

  /* Truncation controls */
  max-width: ${({ maxwidth }) => maxwidth || 'auto'};
  ${({ nowrap }) =>
    nowrap !== 'No'
      ? `
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      `
      : `
        white-space: normal;
        overflow: visible;
      `}

  /* Row-level hover */
  tr:hover & {
    background-color: #f9f9f9;
  }

  /* Optional clickable cell styling */
  ${({ clickable }) =>
    clickable === 'Yes' &&
    `
      cursor: pointer;
      tr:hover & {
        background-color: #e6f0ff;
        color: #003366;
      }
    `}
`;

const TableData = memo(
  ({ children, align, compact, maxWidth, nowrap = 'Yes', clickable = 'No' }) => (
    <StyledTableData
      align={align}
      compact={compact}
      maxwidth={maxWidth}
      nowrap={nowrap}
      clickable={clickable}
    >
      {children}
    </StyledTableData>
  )
);

export default TableData;
